import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ReactLenis } from "lenis/react";
import { Toaster } from "sonner";
import LandingPage from "@/pages/LandingPage";
import LeadsPage from "@/pages/LeadsPage";

function App() {
  return (
    <ReactLenis root options={{ lerp: 0.09, wheelMultiplier: 0.95 }}>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/leads" element={<LeadsPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-center" />
    </ReactLenis>
  );
}

export default App;
